import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Helmet } from "react-helmet-async";

export function GlobalScripts() {
  const { data } = useQuery({
    queryKey: ["global-settings-scripts"],
    queryFn: async () => {
      // Read GA and verification settings from site_settings table
      const { data, error } = await supabase
        .from("site_settings")
        .select("setting_key, setting_value")
        .in("setting_key", ["google_analytics_id", "google_site_verification"]);

      if (error) {
        console.error("Failed to load global scripts", error);
        return null;
      }

      if (!data || data.length === 0) return null;

      const settings: Record<string, string> = {};
      for (const row of data) {
        settings[row.setting_key] = row.setting_value;
      }
      return settings;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  if (!data) return null;

  return (
    <Helmet>
      {/* Google Search Console Verification */}
      {data.google_site_verification && (
        <meta name="google-site-verification" content={data.google_site_verification} />
      )}

      {/* Google Analytics (GA4) */}
      {data.google_analytics_id && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${data.google_analytics_id}`}></script>
      )}
      {data.google_analytics_id && (
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${data.google_analytics_id}');
          `}
        </script>
      )}
    </Helmet>
  );
}
